/**
 * Special Utils
 */
import ChatUtils from './ChatUtils';
import ee from '../../../../../UmiCore/src/EventDriver';

// SPECIAL MESSAGES FUNCTIONS
window.jsReferral = (ref) => {
  // ee.emit('hu-lb-message-referral', ref);
}

window.fakeMessage = (message) => {
  ChatUtils.sendMessage(message);
}

window.ghostMessage = (message) => {
  ee.emit('hu-receive-ghost-message', Object.assign(
    { key: ChatUtils.randomKey() },
    message
  ));
}

const SpecialUtils = {
  getReferralUrl: (type, { brand/*, url_referral*/ }) => {
    const url_referral = (window.location != window.parent.location) ?
      document.referrer : document.location.href;
    switch(type) {
      case 'facebook':
        return `https://facebook.com/sharer/sharer.php?u=${encodeURI(url_referral)}`;
      case 'twitter':
        return `https://twitter.com/intent/tweet/?text=Try%20this%20conversational%20website%20made%20with%20Landbot.io%20%F0%9F%A4%96%20%F0%9F%92%AC%20%20&amp;url=${encodeURI(url_referral)}`;
      case 'linkedin':
        return `https://www.linkedin.com/shareArticle?mini=true&amp;url=${encodeURI(url_referral)}&amp;title=Try%20this%20conversational%20website%20made%20with%20Landbot.io%20%F0%9F%A4%96%20%F0%9F%92%AC%20%20&amp;summary=Landbot.io%20is%20a%20tool%20to%20create%20conversational%20interfaces%20in%20substitution%20of%20forms.%20No%20coding%20required!&amp;source=${encodeURI(url_referral)}`
      case 'whatsapp':
        return `https://api.whatsapp.com/send?text=Try%20this%20conversational%20website%20made%20with%20Landbot.io%20%F0%9F%A4%96%20%F0%9F%92%AC%20%20%20${encodeURI(url_referral)}`
    }
  }
}

export default SpecialUtils;


// WEBPACK FOOTER //
// ./app/js/components/utils/SpecialUtils.js